import React from 'react';

import PropTypes from 'prop-types';

import MainFont from 'ui/typography/mainFont';

import {
  getCampaignStatusColor,
  getChargerStatusColor,
  getDriversStatusColor,
  getStateColor,
  graphPalette
} from 'utils/graphPalette';

import { Container, Item, Labels, LineBar, PercentageLine } from './style';

const ProgressBar = ({
  states = {},
  corporateDashboard = false,
  corporateAtAGlance = false,
  privateFota = false
}) => {
  const filteredArray = () =>
    Object.keys(states).map(k => ({ status: k, quantity: states[k] }));

  const total = filteredArray()?.reduce((acc, item) => acc + item.quantity, 0);

  if (corporateDashboard) {
    return (
      <Container>
        <LineBar background={graphPalette().shade5}>
          {filteredArray()?.map((state, index) => {
            const zIndex = filteredArray().length - index;
            return (
              <PercentageLine
                quantity={state.quantity}
                color={getDriversStatusColor(state.status).primary}
                key={index}
                total={total}
                index={index}
                zIndex={zIndex}
              />
            );
          })}
        </LineBar>
        <Labels corporate>
          {filteredArray()?.map((state, index) => (
            <Item
              key={index}
              color={getDriversStatusColor(state.status).primary}
            >
              <MainFont>
                {getDriversStatusColor(state.status).label} ({state.quantity})
              </MainFont>
            </Item>
          ))}
        </Labels>
      </Container>
    );
  }
  if (corporateAtAGlance) {
    return (
      <Container>
        <LineBar background={graphPalette().shade5}>
          {filteredArray()?.map((state, index) => {
            const zIndex = filteredArray().length - index;
            if (state.quantity === 0) return null;
            return (
              <PercentageLine
                quantity={state.quantity}
                color={getChargerStatusColor(state.status).primary}
                key={index}
                total={total}
                index={index}
                zIndex={zIndex}
              />
            );
          })}
        </LineBar>
        <Labels corporate atGlance>
          {filteredArray()?.map((state, index) => (
            <Item
              key={index}
              color={getChargerStatusColor(state.status).primary}
              atGlance
            >
              <MainFont>
                {getChargerStatusColor(state.status).label} ({state.quantity})
              </MainFont>
            </Item>
          ))}
        </Labels>
      </Container>
    );
  }
  if (privateFota) {
    return (
      <Container>
        <LineBar background={graphPalette().shade5}>
          {filteredArray()?.map((state, index) => {
            const zIndex = filteredArray().length - index;
            if (state.quantity === 0) return null;
            return (
              <PercentageLine
                quantity={state.quantity}
                color={getCampaignStatusColor(state.status).primary}
                key={index}
                total={total}
                index={index}
                zIndex={zIndex}
              />
            );
          })}
        </LineBar>
        <Labels privateFota>
          {filteredArray()?.map((state, index) => (
            <Item
              key={index}
              color={getCampaignStatusColor(state.status).primary}
              privateFota
            >
              <MainFont>
                {getCampaignStatusColor(state.status).label} ({state.quantity})
              </MainFont>
            </Item>
          ))}
        </Labels>
      </Container>
    );
  }

  return (
    <Container>
      <LineBar background={graphPalette().shade5}>
        {filteredArray()?.map((state, index) => {
          const zIndex = filteredArray().length - index;
          return (
            <PercentageLine
              quantity={state.quantity}
              color={getStateColor(state.status).primary}
              key={index}
              total={total}
              index={index}
              zIndex={zIndex}
            />
          );
        })}
      </LineBar>
      <Labels>
        {filteredArray()?.map((state, index) => (
          <Item key={index} color={getStateColor(state.status).primary}>
            <MainFont>
              {getStateColor(state.status).label} ({state.quantity})
            </MainFont>
          </Item>
        ))}
      </Labels>
    </Container>
  );
};

ProgressBar.propTypes = {
  states: PropTypes.object,
  corporateDashboard: PropTypes.bool,
  corporateAtAGlance: PropTypes.bool,
  privateFota: PropTypes.bool
};

ProgressBar.defaultProps = {};

export default ProgressBar;
